import One from "./1.jpg";
import Two from "./2.jpg";
import Three from "./3.jpg";
import Four from "./4.jpg";
import Five from "./5.jpg";

const Exterior = [One, Two, Three, Four, Five];
export default Exterior;
